import Vue from 'vue'
import VueRouter from 'vue-router'
import LandingPage from '../views/LandingPage.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/landing-page',
  name: 'LANDINGPAGE',
  component: LandingPage
}]

const router = new VueRouter({
  routes
})

export default router
